export default __webpack_public_path__ + "static/media/448.af9598d6.gif";